import {
  getTreeRelationshipAuthorities,
} from './TreeRelationshipAuthority';

import {
  getTreeRelationshipRegistry,
} from './TreeRelationshipRegistry';

import {
  getTreeConnectorAuthorities,
  REQUIRED_CANONICAL_TREE_CONNECTORS,
  hasCanonicalTreeConnectorAuthority,
} from './TreeConnectorAuthority';

import {
  getCanonicalTreeRelationshipPathContracts,
  verifyCanonicalTreeRelationshipPathContracts,
} from './CanonicalTreeRelationshipPathAuthority';

export interface TreeRelationshipVerificationResult {
  readonly passed: boolean;
  readonly relationshipsVerified: number;
  readonly connectorsVerified: number;
  readonly authoritiesVerified: number;
  readonly verifiedAt: string;
}

export function verifyTreeRelationships():
TreeRelationshipVerificationResult {

  const authorities =
    getTreeRelationshipAuthorities();

  const registry =
    getTreeRelationshipRegistry();

  const connectors =
    getTreeConnectorAuthorities();

  const pathContracts =
    getCanonicalTreeRelationshipPathContracts();

  const pathContractVerification =
    verifyCanonicalTreeRelationshipPathContracts();

  const canonicalConnectorCoverage =
    REQUIRED_CANONICAL_TREE_CONNECTORS.every(
      hasCanonicalTreeConnectorAuthority,
    );

  const passed =
    authorities.length > 0 &&
    registry.length > 0 &&
    connectors.length > 0 &&
    canonicalConnectorCoverage &&
    pathContracts.length === 50 &&
    pathContractVerification.passed;

  return Object.freeze({
    passed,
    relationshipsVerified: registry.length,
    connectorsVerified: connectors.length,
    authoritiesVerified: authorities.length,
    verifiedAt: new Date().toISOString(),
  });
}
